import '@axmit/garwin-api';
import { IRequestSuccess } from 'common/models';

export enum ESelfRegistrationStep {
  Profile = 'profile',
  Legals = 'legals',
  Addresses = 'addresses',
  Completed = 'completed',
}

export interface ISelfRegistrationStepResponse extends Components.Schemas.SelfRegistrationStepResponse {}
export interface IUpdateProfilePayload extends Components.Schemas.UpdateSelfRegistrationProfileDto, IRequestSuccess {}
